module.exports = __webpack_public_path__ + "static/img/avatar-josie.3e58842.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar-josie.png
// module id = Mv/S
// module chunks = 1